import { DownloadBlob } from '@/services/axiosHelper';
import vkbeautify from 'vkbeautify';

// vuex
import store from '@/store';

export default new (class BlobService {
	constructor() {}

	async DownloadSecurevueTransaction(blobUri, contentType) {
		const service = DownloadBlob(contentType);
		blobUri = encodeURIComponent(blobUri);

		await service
			.download(`/blobs/securevue?blobUri=${blobUri}`)
			.then(response => {
				window.open(
					URL.createObjectURL(
						new Blob([response], {
							type: contentType
						})
					),
					'_blank'
				);
			})
			.catch(() => {
				return store.dispatch('toastMessages/push', {
					statusCode: 400,
					message:
						'An error occurred while trying to download the file'
				});
			});
	}

	async DownloadSecurevueTransactionContent(blobUri, contentType) {
		const service = DownloadBlob(contentType);
		blobUri = encodeURIComponent(blobUri);

		return new Promise((resolve, reject) => {
			service
				.download(`/blobs/securevue?blobUri=${blobUri}`)
				.then(response => {
					const textDecoder = new TextDecoder('utf-8');
					let xmlRes = textDecoder.decode(response);

					if (
						!xmlRes.includes(
							"<?Xml Version='1.0' Encoding='Utf-8'?>"
						)
					) {
						xmlRes =
							"<?Xml Version='1.0' Encoding='Utf-8'?>" + xmlRes;
					}

					resolve(vkbeautify.xml(xmlRes));
				})
				.catch(() => {
					reject();
					return store.dispatch('toastMessages/push', {
						statusCode: 400,
						message:
							'An error occurred while trying to download the file'
					});
				});
		});
	}
	DownloadAll(data, contentType, id) {
		var newBlob = new Blob([data], {
			type: contentType
		});
		const fileUrl = document.createElement('a');
		fileUrl.href = URL.createObjectURL(newBlob);

		fileUrl.download = 'Transaction_' + id + '.zip';
		fileUrl.click();
		URL.revokeObjectURL(fileUrl.href);
	}

	async getSecureVueTransaction(blobUri, contentType) {
		const service = DownloadBlob(contentType);
		blobUri = encodeURIComponent(blobUri);

		return new Promise((resolve, reject) => {
			service
				.download(`/blobs/securevue?blobUri=${blobUri}`)
				.then(response => {
					const textDecoder = new TextDecoder('utf-8');
					resolve(textDecoder.decode(response));
				})
				.catch(() => {
					reject();
					return store.dispatch('toastMessages/push', {
						statusCode: 400,
						message:
							'An error occurred while trying to obtain the transaction.'
					});
				});
		});
	}
})();
